/* ============================================================
   Hero Product Gallery — LP 5 Razões Bundles
   ------------------------------------------------------------
   FEATURE PERMANENTE (vencedora do AB#02, promovida a 100% em 07/Jul/2026 —
   o motor/sorteio A/B foi removido). Carregada direto pelo theme.liquid
   (path-guard da LP), sem depender de ab-test-2.js.

   JS AUTO-SUFICIENTE: substitui a imagem ESTÁTICA da hero (.lp-hero-img)
   por uma GALERIA INTERATIVA de produto (imagem grande 1:1 + setas + 5 thumbs).
   Mesmo estilo/UX da galeria do pop-up cross-sell (ups-c.js), agora na hero.
   A 1ª imagem (HEADER) é a original da hero — as outras 4 entram na galeria.

   Não depende de section/snippet do tema. Idempotente. Resiliente: se a hero
   não montar ainda, tenta de novo; se falhar, a imagem original fica intacta.

   1º SLIDE = a imagem ATUAL do setting "[foto] do hero" do editor: o JS lê o
   <img> que o Liquid renderizou dentro de .lp-hero-img antes de trocar pela
   galeria. A URL em CFG.images[0] é só FALLBACK (hero vazia/placeholder).
   ============================================================ */
(function () {
  'use strict';

  /* ====== CONFIG (editável) ====== */
  var CFG = {
    heroSelector: '.lp-hero-img',          // container da imagem da hero (será trocado pela galeria)
    // 5 imagens da galeria. URLs base — width anexado pelo JS.
    // A 1ª é SOBRESCRITA em runtime pela imagem do editor ([foto] do hero); fica aqui só como fallback.
    // Ordem: 1-HEADER (fallback) · 2-TikTok · 3-PDP (tabela comparativa) · 4-Foto_6 · 5-Prancheta
    images: [
      'https://guday.com.br/cdn/shop/files/banner-guday.jpg?v=1784168956',
      'https://guday.com.br/cdn/shop/files/TIKTOK_MV2_-_3.jpg?v=1773339852',
      'https://guday.com.br/cdn/shop/files/PDP_-_MACA_5_1.jpg?v=1776367059',
      'https://guday.com.br/cdn/shop/files/Foto_6.jpg?v=1776367059',
      'https://guday.com.br/cdn/shop/files/Prancheta_16.png?v=1773339852'
    ],
    alt: 'Creatina Guday em gummies',
    autoAdvanceMs: 0                        // 0 = sem autoplay (avaliar depois). >0 = ms entre slides.
  };

  if (window.__gdGalleryHeroInit) return;   // idempotência
  window.__gdGalleryHeroInit = true;

  /* ====== 1) injeta o CSS (namespace .gd-gh*) ====== */
  function injectCSS() {
    if (document.getElementById('gd-gh-css')) return;
    var s = document.createElement('style');
    s.id = 'gd-gh-css';
    s.textContent =
      '.gd-gh{display:flex;flex-direction:column;gap:12px;width:100%;}' +
      '.gd-gh-main{position:relative;width:100%;border-radius:16px;overflow:hidden;background:#fff;aspect-ratio:1/1;}' +
      '.gd-gh-main img{width:100%;height:100%;object-fit:cover;display:block;}' +
      /* !important: a LP tem `.lp-5razb-wrap button{background:none}` que zera o fundo das setas (são <button>). */
      '.gd-gh-nav{position:absolute;top:50%;transform:translateY(-50%);width:40px;height:40px;border-radius:999px;background:#fff !important;border:none !important;box-shadow:0 4px 14px rgba(0,0,0,.22);display:grid;place-items:center;cursor:pointer;color:#1E192A !important;z-index:2;-webkit-tap-highlight-color:transparent;}' +
      '.gd-gh-nav:hover{background:#fff !important;box-shadow:0 6px 18px rgba(0,0,0,.28);}' +
      '.gd-gh-nav:active{transform:translateY(-50%) scale(.92);}' +
      '.gd-gh-nav--l{left:12px;}.gd-gh-nav--r{right:12px;}' +
      '.gd-gh-nav svg{width:18px;height:18px;}' +
      '.gd-gh-dots{position:absolute;left:0;right:0;bottom:12px;display:flex;justify-content:center;gap:6px;z-index:2;}' +
      '.gd-gh-dot{width:7px;height:7px;border-radius:50%;background:rgba(255,255,255,.6);box-shadow:0 0 0 1px rgba(0,0,0,.08);}' +
      '.gd-gh-dot.is-active{background:#fff;width:18px;border-radius:99px;}' +
      '.gd-gh-thumbs{display:flex;gap:10px;width:100%;}' +
      /* seleção: borda DIRETO na imagem (que fica por cima e esconderia um box-shadow do botão).
         outline na img + outline-offset negativo desenha por dentro, sobre a imagem, seguindo o radius. */
      '.gd-gh-thumb{flex:1 1 0;min-width:0;aspect-ratio:1/1;border-radius:10px;cursor:pointer;border:none !important;background:#fff !important;padding:0;-webkit-tap-highlight-color:transparent;}' +
      '.gd-gh-thumb img{width:100%;height:100%;object-fit:cover;display:block;border-radius:10px;outline:0 solid #B282EB;outline-offset:-3px;transition:outline-width .12s;}' +
      '.gd-gh-thumb.is-active img{outline-width:3.5px !important;}' +
      '@media(max-width:760px){.gd-gh-thumbs{gap:8px;}.gd-gh-nav{width:36px;height:36px;}}';
    document.head.appendChild(s);
  }

  /* ====== 2) helpers de imagem ====== */
  function withWidth(url, w) {
    // anexa &width=w à URL da CDN do Shopify (já tem ?v=)
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function stripWidth(url) {
    // remove o width que o Liquid (image_url: width: 1200) anexou — o JS re-anexa o dele
    return url.replace(/([?&])width=\d+&/, '$1').replace(/[?&]width=\d+$/, '');
  }

  /* ====== 3) monta a galeria e troca o conteúdo da hero ====== */
  var cur = 0, total = CFG.images.length, mainImg, thumbsWrap, dotsWrap, autoTimer;

  function show(i) {
    cur = (i + total) % total;
    if (mainImg) mainImg.src = withWidth(CFG.images[cur], 900);
    if (thumbsWrap) thumbsWrap.querySelectorAll('.gd-gh-thumb').forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
    if (dotsWrap) dotsWrap.querySelectorAll('.gd-gh-dot').forEach(function (d, k) { d.classList.toggle('is-active', k === cur); });
  }
  function next() { show(cur + 1); }
  function prev() { show(cur - 1); }

  function buildGallery() {
    var host = document.querySelector(CFG.heroSelector);
    if (!host) return false;
    if (host.querySelector('.gd-gh')) return true; // já montada

    // 1º slide = imagem ATUAL do editor ([foto] do hero), lida do <img> que o
    // Liquid renderizou antes de trocarmos pelo carrossel. Sem <img> (hero
    // vazia → placeholder), fica o fallback hardcoded do CFG.
    var liquidImg = host.querySelector('img');
    var liquidSrc = liquidImg && (liquidImg.getAttribute('src') || '');
    if (liquidSrc) CFG.images[0] = stripWidth(liquidSrc);

    var wrap = document.createElement('div');
    wrap.className = 'gd-gh';
    var navSvgL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
    var navSvgR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

    // main + setas + dots
    var dots = '';
    for (var d = 0; d < total; d++) dots += '<span class="gd-gh-dot' + (d === 0 ? ' is-active' : '') + '"></span>';
    wrap.innerHTML =
      '<div class="gd-gh-main">' +
        '<img id="gd-gh-main-img" src="' + withWidth(CFG.images[0], 900) + '" alt="' + CFG.alt + '" fetchpriority="high">' +
        '<button class="gd-gh-nav gd-gh-nav--l" type="button" aria-label="Anterior" data-gh-prev>' + navSvgL + '</button>' +
        '<button class="gd-gh-nav gd-gh-nav--r" type="button" aria-label="Próximo" data-gh-next>' + navSvgR + '</button>' +
        '<div class="gd-gh-dots">' + dots + '</div>' +
      '</div>' +
      '<div class="gd-gh-thumbs" id="gd-gh-thumbs"></div>';

    // troca o conteúdo da hero pela galeria
    host.innerHTML = '';
    host.appendChild(wrap);

    mainImg = wrap.querySelector('#gd-gh-main-img');
    thumbsWrap = wrap.querySelector('#gd-gh-thumbs');
    dotsWrap = wrap.querySelector('.gd-gh-dots');

    // thumbs
    CFG.images.forEach(function (url, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gd-gh-thumb' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Imagem ' + (i + 1));
      b.innerHTML = '<img src="' + withWidth(url, 160) + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { stopAuto(); show(i); });
      thumbsWrap.appendChild(b);
    });

    // setas
    wrap.querySelector('[data-gh-prev]').addEventListener('click', function () { stopAuto(); prev(); });
    wrap.querySelector('[data-gh-next]').addEventListener('click', function () { stopAuto(); next(); });

    // swipe no mobile
    var x0 = null;
    var mainBox = wrap.querySelector('.gd-gh-main');
    mainBox.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    mainBox.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { stopAuto(); (dx < 0 ? next : prev)(); }
      x0 = null;
    }, { passive: true });

    if (CFG.autoAdvanceMs > 0) startAuto();
    return true;
  }

  function startAuto() { stopAuto(); autoTimer = setInterval(next, CFG.autoAdvanceMs); }
  function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }

  /* ====== init ====== */
  function init() {
    injectCSS();
    if (buildGallery()) return;
    // a hero pode montar depois: tenta de novo por alguns segundos
    var tries = 0, iv = setInterval(function () {
      tries++;
      if (buildGallery() || tries > 20) clearInterval(iv);
    }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
